module.exports = __webpack_public_path__ + "media/35.e08b35f5.mp3";